export enum LabelMarker {
  None = 0, Triangle, Pin, Point
}
